/**
 * True when a product's tags include the final-sale tag, allowing for
 * spacing/underscore variations set in Shopify (e.g. "Final Sale").
 */
export function hasFinalSaleTag(tags = []) {
  return (tags || []).some((tag) => {
    const normalizedTag = String(tag)
      .trim()
      .toLowerCase()
      .replace(/[_\s]+/g, "-");
    return normalizedTag === "final-sale";
  });
}
